module.exports = __webpack_public_path__ + "world2cover-logo.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/world2cover-logo.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/world2cover-logo.png
// module chunks = 10